// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogsPopularFeed":"jv_a bhb_px bhb_a bhb_w","BlogsPopularFeed__loading":"jv_b"};